import type { CSSProperties, FC } from 'react';

type HeartFilledIconProps = {
	className?: string;
	style?: CSSProperties;
};

const HeartFilledIcon: FC<HeartFilledIconProps> = ({ className, style }) => {
	return (
		<svg
			aria-hidden="true"
			className={className}
			fill="none"
			focusable="false"
			height={44}
			style={style}
			viewBox="0 0 51 44"
			width={51}
		>
			<title>Filled heart</title>
			<path
				d="M0.325012 14.2646C0.325063 11.4525 1.16899 8.7066 2.74534 6.38949C4.32168 4.07238 6.55629 2.29311 9.15401 1.28669C11.7517 0.280268 14.5904 0.0940334 17.295 0.752584C19.9996 1.41113 22.443 2.88349 24.3024 4.97519C24.4334 5.11674 24.5917 5.22958 24.7676 5.30674C24.9435 5.38389 25.1332 5.4237 25.3249 5.4237C25.5167 5.4237 25.7064 5.38389 25.8822 5.30674C26.0581 5.22958 26.2165 5.11674 26.3474 4.97519C28.201 2.86989 30.645 1.38517 33.354 0.718614C36.063 0.0520622 38.9086 0.235302 41.5121 1.24394C44.1155 2.25259 46.3533 4.03879 47.9276 6.36482C49.502 8.69085 50.3381 11.4464 50.3249 14.2646C50.3249 20.0516 46.5749 24.3729 42.8249 28.1635L29.0949 41.5897C28.6291 42.1305 28.0547 42.5649 27.41 42.8641C26.7653 43.1633 26.065 43.3204 25.3557 43.3249C24.6463 43.3294 23.9441 43.1814 23.2957 42.8905C22.6473 42.5996 22.0675 42.1725 21.5949 41.6377L7.82499 28.1635C4.075 24.3729 0.325012 20.0769 0.325012 14.2646Z"
				fill="#2B7FFF"
			/>
			<path
				d="M0.325012 14.2646C0.325063 11.4525 1.16899 8.7066 2.74534 6.38949C4.32168 4.07238 6.55629 2.29311 9.15401 1.28669C11.7517 0.280268 14.5904 0.0940334 17.295 0.752584C19.9996 1.41113 22.443 2.88349 24.3024 4.97519C24.4334 5.11674 24.5917 5.22958 24.7676 5.30674C24.9435 5.38389 25.1332 5.4237 25.3249 5.4237C25.5167 5.4237 25.7064 5.38389 25.8822 5.30674C26.0581 5.22958 26.2165 5.11674 26.3474 4.97519C28.201 2.86989 30.645 1.38517 33.354 0.718614C36.063 0.0520622 38.9086 0.235302 41.5121 1.24394C44.1155 2.25259 46.3533 4.03879 47.9276 6.36482C49.502 8.69085 50.3381 11.4464 50.3249 14.2646C50.3249 20.0516 46.5749 24.3729 42.8249 28.1635L29.0949 41.5897C28.6291 42.1305 28.0547 42.5649 27.41 42.8641C26.7653 43.1633 26.065 43.3204 25.3557 43.3249C24.6463 43.3294 23.9441 43.1814 23.2957 42.8905C22.6473 42.5996 22.0675 42.1725 21.5949 41.6377L7.82499 28.1635C4.075 24.3729 0.325012 20.0769 0.325012 14.2646Z"
				fill="url(#paint0_radial_244_13601)"
			/>
			<path
				d="M0.325012 14.2646C0.325063 11.4525 1.16899 8.7066 2.74534 6.38949C4.32168 4.07238 6.55629 2.29311 9.15401 1.28669C11.7517 0.280268 14.5904 0.0940334 17.295 0.752584C19.9996 1.41113 22.443 2.88349 24.3024 4.97519C24.4334 5.11674 24.5917 5.22958 24.7676 5.30674C24.9435 5.38389 25.1332 5.4237 25.3249 5.4237C25.5167 5.4237 25.7064 5.38389 25.8822 5.30674C26.0581 5.22958 26.2165 5.11674 26.3474 4.97519C28.201 2.86989 30.645 1.38517 33.354 0.718614C36.063 0.0520622 38.9086 0.235302 41.5121 1.24394C44.1155 2.25259 46.3533 4.03879 47.9276 6.36482C49.502 8.69085 50.3381 11.4464 50.3249 14.2646C50.3249 20.0516 46.5749 24.3729 42.8249 28.1635L29.0949 41.5897C28.6291 42.1305 28.0547 42.5649 27.41 42.8641C26.7653 43.1633 26.065 43.3204 25.3557 43.3249C24.6463 43.3294 23.9441 43.1814 23.2957 42.8905C22.6473 42.5996 22.0675 42.1725 21.5949 41.6377L7.82499 28.1635C4.075 24.3729 0.325012 20.0769 0.325012 14.2646Z"
				stroke="#2B7FFF"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.65"
			/>
			<defs>
				<radialGradient
					cx="0"
					cy="0"
					gradientTransform="translate(25.325 21.825) rotate(90) scale(21.5 25)"
					gradientUnits="userSpaceOnUse"
					id="paint0_radial_244_13601"
					r="1"
				>
					<stop stopColor="#5095FF" />
					<stop
						offset="1"
						stopColor="#2B7FFF"
					/>
				</radialGradient>
			</defs>
		</svg>
	);
};

export default HeartFilledIcon;
